import { lazy, ReactNode, Suspense } from 'react';

import { Fallback } from 'router/Fallback';

const ServiceCenterHome = lazy(() => import('pages/service-center/ServiceCenterHome'));
const ServiceCenterUpdates = lazy(() => import('pages/service-center/ServiceCenterUpdates'));
const FlipperRequestPage = lazy(() => import('pages/service-center/flipper/FlipperRequest'));
const FlipperSuccessPage = lazy(() => import('pages/service-center/flipper/FlipperSuccess'));
const FlipperErrorPage = lazy(() => import('pages/service-center/flipper/FlipperError'));

const wrap = (element: ReactNode) => <Suspense fallback={<Fallback />}>{element}</Suspense>;

export const ServiceCenterRoutes = [
  {
    path: 'service-center',
    children: [
      {
        index: true,
        element: (
          <Suspense fallback={<Fallback />}>
            <ServiceCenterHome />
          </Suspense>
        ),
      },
      {
        path: 'updates',
        element: (
          <Suspense fallback={<Fallback />}>
            <ServiceCenterUpdates />
          </Suspense>
        ),
      },
      {
        path: 'update-tool',
        children: [
          { index: true, element: wrap(<FlipperRequestPage />) },
          { path: 'success', element: wrap(<FlipperSuccessPage />) },
          { path: 'error', element: wrap(<FlipperErrorPage />) },
        ],
      },
    ],
  },
];
